document.addEventListener('DOMContentLoaded', function() {
    // Modal toggle logic
    const feedbackComponent = document.getElementById('feedbackComponent');
    const isPopupOpen = feedbackComponent.dataset.modalOpen;
    const feedbackButton = document.getElementById('feedbackButton');
    const closeButton = document.getElementById('closeButton');

    function toggleModal(close = false) {
        if (!close) {
            document.querySelector('[name="feedback_page_url"]').value = window.location.href;
            document.querySelector('[name="feedback_device_info"]').value = window.navigator.userAgent;
            document.body.classList.add('modal-open-no-scroll');
            closeButton.focus();
        } else {
            document.body.classList.remove('modal-open-no-scroll');
        }
        feedbackComponent.dataset.modalOpen = !close;
        showThankYouMessage(false);
        toggleFormError(false);
        resetFields();
    }

    feedbackButton.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
            toggleModal(isPopupOpen === 'true');
        }
    });

    feedbackButton.addEventListener('click', function() {
        toggleModal(isPopupOpen === 'true');
    });

    closeButton.addEventListener('click', function() {
        toggleModal(true);
    });

    // Radio group validation logic
    const radioGroups = document.querySelectorAll('[role="radiogroup"]');
    radioGroups.forEach(radioGroup => {
        radioGroup.addEventListener('change', function() {
            const input = radioGroup.querySelector('input:checked');
            if (input) {
                radioGroup.setAttribute('aria-invalid', 'false');
                toggleFieldError(input, false);
            }
        });

        const radioButtons = radioGroup.querySelectorAll('input[type="radio"]');
        let currentIndex = 0;
        radioButtons.forEach((radio, index) => {
            radio.setAttribute('tabindex', '0');
            radio.addEventListener('keydown', function (e) {
                if (e.key === 'Tab') {
                    currentIndex = index;
                    const nextIndex = e.shiftKey ? currentIndex - 1 : (currentIndex + 1) % radioButtons.length;
                    if ((!e.shiftKey && currentIndex !== radioButtons.length - 1) || (e.shiftKey && nextIndex >= 0)) {
                        e.preventDefault();
                        radioButtons[nextIndex].focus();
                    }
                }
            });
        });
    });

    // Textarea character count validation
    const textarea = document.getElementById('feedback_message');
    if (textarea) {
        const modernField = textarea.closest('.modern-field');
        const maxLen = parseInt(textarea.dataset.inputMax, 10);

        textarea.addEventListener('input', function() {
            const currentLength = textarea.value.length;
            const inputMaxContainer = modernField.querySelector('.input-max');
            if (currentLength > maxLen) {
                modernField.classList.add('has-error');
                inputMaxContainer.classList.add('text-error');
                inputMaxContainer.textContent = `Exceeded the maximum character ${currentLength}/${maxLen}`;
            } else {
                modernField.classList.remove('show-error');
                modernField.classList.remove('has-error');
                inputMaxContainer.classList.remove('text-error');
                inputMaxContainer.textContent = `${currentLength}/${maxLen} Max`;
            }
        });
    }
    async function submitForm(form) {
        const submitButton = form.querySelector('button');
        const formData = new FormData(form);
        const apiUrl = form.getAttribute('action');
        const notValid = validateFields();
        if (notValid) return;
        try {
            submitButton.disabled = true;
            showLoader(true);
            const response = await fetch(apiUrl, {
                method: 'POST',
                body: formData
            });
            const result = await response.json();
            const { status, invalid_fields } = result;

            if (status === 'validation_failed') {
                invalid_fields.forEach(({ field }) => {
                    const fieldElement = document.querySelector(`[name="${field}"]`);
                    if (fieldElement) toggleFieldError(fieldElement, true);
                    showLoader(false);
                });
            } else if (status === 'mail_sent') {
                showThankYouMessage(true);
                form.reset();
            } else if (status === 'spam') {
                console.error(result?.message);
                toggleFormError(true);
                showLoader(false);
            } else {
                console.error(result);
                toggleFormError(true);
                showLoader(false);
            }
            submitButton.disabled = false;
        } catch (error) {
            console.error(error);
            submitButton.disabled = false;
            toggleFormError(true);
            showLoader(false);
        }
    }
    // Form submission logic
    const form = document.getElementById('feedbackForm');
    if (form) {
        form.addEventListener('submit', async function(event) {
            event.preventDefault();
            try {
                grecaptcha.ready(async () => {
                    const token = await grecaptcha.execute('6LfrvFMqAAAAALeqepYXuKzOt35CIFHGf9HSywO9', {action: 'submit'});
                    document.querySelector('[name="_wpcf7_recaptcha_response"]').value = token;
                    await submitForm(form);
                });
            } catch (e) {
                toggleFormError(true);
                console.error('grecaptcha error');
                console.error(e);
            }
        });
    }

    function validateFields() {
        const fields = form.querySelectorAll('[aria-required="true"]');
        let notValid = false;
        fields.forEach((field) => {
            let hasValue = false;

            if (field.role === 'radiogroup') {
                const radios = field.querySelectorAll('input[type="radio"]');
                hasValue = Array.from(radios).some(radio => radio.checked);
            } else {
                let input = field.querySelector('input');
                if (!input) {
                    input = field.querySelector('textarea');
                }
                const value = input?.value || '';
                hasValue = !!value.trim();
            }

            if (!hasValue) notValid = true;
            toggleFieldError(field, !hasValue)
        });
        const textFields = document.querySelectorAll('[data-input-max]');
        textFields.forEach((field) => {
            const currentLength = field.value.length;
            const maxLength = field.dataset.inputMax;
            if (currentLength > maxLength) notValid = true;
        });
        if (document.querySelector('.show-error input')) {
            console.log('FOCUS')
            document.querySelector('.show-error input').focus();
        }
        return notValid;
    }

    function showThankYouMessage(show = false) {
        document.querySelector('.feedback__loader').style.display = 'none';
        document.querySelector('.feedback__content').style.display = show ? 'none' : 'block';
        document.querySelector('.feedback__success').style.display = show ? 'block' : 'none';
    }

    function showLoader(show = false) {
        document.querySelector('.feedback__success').style.display = 'none';
        document.querySelector('.feedback__content').style.display = show ? 'none' : 'block';
        document.querySelector('.feedback__loader').style.display = show ? 'flex' : 'none';
    }

    // Toggle field error helper function
    function toggleFieldError(field, error = false) {
        const modernField = field.closest('.modern-field');
        if (modernField) {
            if (error) {
                modernField.classList.add('show-error');
                modernField.setAttribute('aria-invalid', 'true');
            } else {
                modernField.classList.remove('show-error');
                modernField.setAttribute('aria-invalid', 'false');
            }
        }
    }

    function toggleFormError(showError = false) {
        const submitButton = form.querySelector('button');
        const formError = form.querySelector('.feedback-form__error');
        if (showError) {
            submitButton.classList.add('button-error');
            formError.classList.add('show-error');
            setTimeout(() => {
                submitButton.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }, 1);
        } else {
            submitButton.classList.remove('button-error');
            formError.classList.remove('show-error');
        }
    }

    function resetFields() {
        const textarea = document.getElementById('feedback_message');
        const maxLen = parseInt(textarea.dataset.inputMax, 10);
        const inputMaxContainers = document.querySelectorAll('.modern-field .input-max');
        inputMaxContainers.forEach((item) => {
            item.textContent = `0/${maxLen} Max`;
        });
    }
});
